// Confirmed organisation facts, shared by page copy, meta tags, JSON-LD and the
// build-time prerender script (scripts/prerender.mjs). Plain JS with no Vite
// imports so Node can load it too.
//
// Only put facts here that WSTSC has confirmed. Class times, term dates, fees,
// parking and social handles other than YouTube are still awaiting
// confirmation - see OWNER_INPUT_NEEDED.md.

export const SITE_URL = "https://wstsc.org.au";

export const ORG = {
  name: "Western Sydney Tamil Study Centre",
  shortName: "WSTSC",
  description:
    "Western Sydney Tamil Study Centre (WSTSC) is a not-for-profit community language school teaching Tamil language and culture to children in Blacktown, outside mainstream school hours.",
  email: "info@wstsc.org.au",
  phones: {
    committee: { label: "Committee", display: "0451 112 478", tel: "+61451112478" },
    principal: { label: "Principal", display: "0469 427 599", tel: "+61469427599" },
  },
  whatsapp: "https://wa.me/61451112478",
  venue: {
    name: "Walters Road Public School",
    streetAddress: "158 Walters Road",
    locality: "Blacktown",
    region: "NSW",
    postcode: "2148",
    country: "AU",
  },
  mapsUrl: "https://maps.app.goo.gl/hMRUGRGpG2YnxCdQ8",
  mapsEmbedUrl:
    "https://www.google.com/maps?q=Walters+Road+Public+School,+158+Walters+Road,+Blacktown+NSW+2148&output=embed",
  hostSchoolPage:
    "https://waltersrd-p.schools.nsw.gov.au/learning-and-support/learning-opportunities/western-sydney-tamil-study-centre-wstsc",
  logo: `${SITE_URL}/wstsc-logo.png`,
  // Only verified official profiles belong here (used for JSON-LD sameAs).
  sameAs: ["https://www.youtube.com/@wstsc-org-au"],
};

export const VENUE_ADDRESS_LINE = `${ORG.venue.streetAddress}, ${ORG.venue.locality} ${ORG.venue.region} ${ORG.venue.postcode}`;

export const DEFAULT_OG_IMAGE = {
  url: `${SITE_URL}/og-image.jpg`,
  width: 1200,
  height: 630,
  alt: "Students and families at a Western Sydney Tamil Study Centre gathering",
};
